import React, { useCallback, useEffect, useState } from 'react';
import { AfterPayBanner, AlertsList, EmptyProductsFallback } from '../../components';
import {
	BREADCRUMB,
	HELPBUTTON,
	PAGETITLE,
	PAYPALBANNER,
	PRODUCTTILES,
	PROMOMSG
} from '../../constants/rootElements';
import { useFeeAlertInjectionScript } from "../../hooks";
import { useGoogleAnalyticsHandler } from '../../hooks/useGoogleAnalyticsHandler';
import { isAllSubCatalogProductsEmpty } from '../../util/isAllSubCatalogProductsEmpty';
import { Breadcrumb } from '../breadcrumb';
import { HelpButton } from '../help';
import { TitleBar } from '../productBrowseTitle';
import { DiplomaProductTiles } from './diplomaProductTile';

export const DiplomaPage = React.memo(({ appData }) => {
	const [pbData, setPbData] = useState({});
	const [catalogData, setCatalogData] = useState({});
	const [breadcrumbData, setBreadcrupmData] = useState([]);
	const [promoMessages, setPromoMessages] = useState([]);
	const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
	const [googleAnalyticsRequestData, setGoogleAnalyticsRequestData] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(null);

	useFeeAlertInjectionScript(feeAlertRequestData);
	const { selectItemTrackingGASY25, viewModalTrackingGASY25, addToCartTrackingGASY25 } = useGoogleAnalyticsHandler(googleAnalyticsRequestData);

	const DiplomaBreadcrumb = Boolean(
		appData?.pagecontentData?.find((data) => data.contentType === 'Navigation')
	);
	const DiplomaTitleBar = appData?.pagecontentData?.find(
		(data) => data.contentType === 'ProductBrowseTitle'
	);
	const ProductBrowseProducts = appData?.pagecontentData?.find(
		(data) => data.contentType === 'ProductBrowseProducts'
	);
	const PaypalBannerData = appData?.pagecontentData?.find(
		(data) => data.contentType === 'PaypalId'
	);
	const DiplomaFilterTile = appData?.pagecontentData?.find(
		(data) => data.contentType === 'ProductBrowseFiltersBar'
	);
	const ProductBrowsePromoMsg = Boolean(
		appData?.pagecontentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

	const getBreadcrumb = useCallback(() => {
		BREADCRUMB.render(<Breadcrumb pbData={breadcrumbData} />);
	}, [breadcrumbData]);

	const getHelpButton = useCallback(() => {
        HELPBUTTON.render(<HelpButton />);
  },[]);

	const getTitleBar = useCallback(() => {
		PAGETITLE.render(
			<TitleBar
				pageContent={DiplomaTitleBar}
				affiliationData={appData?.affiliationData}
			/>
		);
	}, []);

	const productTiles = useCallback(() => {
		const isSubCatalogProductsEmpty = isAllSubCatalogProductsEmpty(catalogData)
		const isProductsEmpty = !Boolean(pbData?.products?.length)

		PRODUCTTILES.render(
			isSubCatalogProductsEmpty && isProductsEmpty
				? <EmptyProductsFallback
					productBrowseData={pbData}
				/>
				: <DiplomaProductTiles
					pbData={pbData}
					pageContent={ProductBrowseProducts}
					filterData={appData.filterData}
					serviceData={catalogData}
					fieldToCompare={DiplomaFilterTile?.filedtocompare}
					googleAnalytics={{ 
						selectItemTrackingGASY25, 
						viewModalTrackingGASY25, 
						addToCartTrackingGASY25,
						catalogOSR: googleAnalyticsRequestData?.catalogOsr,
						customerClassCode: appData.affiliationData?.customerClassCode
					}}
				/>
		)
		// eslint-disable-next-line
	}, [catalogData, selectItemTrackingGASY25]);

	const paypalBanner = useCallback(() => {
		PAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
	},[PaypalBannerData, currencyCode])

	const getPromoMsg = useCallback(() => {
		PROMOMSG.render(<AlertsList messages={promoMessages} />);
	}, [promoMessages]);

	useEffect(() => {
		Object.keys(appData.productBrowseData).map((key) => {
			if (key !== 'metaData') {
				const catalog = appData.productBrowseData[key];
				catalog?.productGroups && Object.keys(catalog.productGroups).map(
					(catObj) => {
						const productGroup = catalog.productGroups[catObj];
						const customerNumber = appData.productBrowseData.metaData.customerNumber;
						setFeeAlertRequestData({
							containerSelector: '#promoMsg',
							customerId: customerNumber,
							catalogOsr: catalog.catalogOsr,
						});
						setGoogleAnalyticsRequestData({
							customerNumber,
							publishedCatalogId: catalog.publishedCatalogId,
							sourceCatalogType: catalog.sourceCatalogType,
							catalogOsr: catalog.catalogOsr,
							customerClassCode: appData.affiliationData?.customerClassCode
						});
						setPbData(productGroup);
						const _currencyCode = productGroup?.products?.[0]?.currencyCode;
						_currencyCode && setCurrencyCode(_currencyCode);
						setPromoMessages(catalog.promoMessages);
						setCatalogData(catalog);
						setPromoMessages(catalog.promoMessages);
						setBreadcrupmData(productGroup);
						return true;
					}
				);
			}
			return true;
		});
	}, [appData.productBrowseData]);

	return (
		<>
			{DiplomaTitleBar && Object.keys(DiplomaTitleBar)?.length > 0 && getTitleBar()}
			{ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
			{DiplomaBreadcrumb && getBreadcrumb()}
			{ProductBrowseProducts &&
				Object.keys(ProductBrowseProducts)?.length > 0 &&
				productTiles()
				}
			{
            getHelpButton()
        	}
			{PaypalBannerData &&
				Object.keys(PaypalBannerData)?.length > 0 &&
				paypalBanner()}
		</>
	);
});
